import StandaloneHeader from '@views/StandaloneHeader';

export const routes = [
  {
    path: '',
    element: <StandaloneHeader />,
  },
];

export default routes;
